module.exports = __webpack_public_path__ + "img/GH-kyujin-top-back003.b1720d5c.webp";